export const TOS_PARAM_MAP = { a: "current", b: "recent_past", c: "none" };

export const UA_PARAM_MAP = {
  1: "ok",
  2: "slightly_upset",
  3: "moderately_upset",
  4: "very_upset",
  5: "extremely_upset",
};

export const getPreSmsChoices = (t) => {
  return {
    mainConcernChoices: [
      { label: t("mainConcernsQuestion.addictions"), value: "addictions" },
      { label: t("mainConcernsQuestion.anxiety"), value: "anxiety" },
      { label: t("mainConcernsQuestion.bullying"), value: "bullying_school" },
      { label: t("mainConcernsQuestion.depression"), value: "depression" },
      {
        label: t("mainConcernsQuestion.discrimination"),
        value: "discrimination",
      },
      {
        label: t("mainConcernsQuestion.eatingDisorder"),
        value: "eating_disorder",
      },
      { label: t("mainConcernsQuestion.familyIssues"), value: "family" },
      {
        label: t("mainConcernsQuestion.financialIssues"),
        value: "financial",
      },
      {
        label: t("mainConcernsQuestion.physicalHealth"),
        value: "physical_health",
      },
      { label: t("mainConcernsQuestion.abuse"), value: "abuse" },
      {
        label: t("mainConcernsQuestion.schoolProblems"),
        value: "school_problems",
      },
      {
        label: t("mainConcernsQuestion.relationshipIssues"),
        value: "relationship_issues",
      },
      { label: t("mainConcernsQuestion.selfHarm"), value: "self_harm" },
      { label: t("mainConcernsQuestion.sexuality"), value: "sexuality" },
      { label: t("mainConcernsQuestion.someoneElse"), value: "someone_else" },
      { label: t("mainConcernsQuestion.violence"), value: "violence" },
      {
        label: t("mainConcernsQuestion.other"),
        value: "not_listed",
        customInput: true,
      },
    ],
  };
};
